export const environment = {
  production: true,
  apiUrl: 'https://api.stage.tokentory.com',
  paypalClientID: 'AbQ3LHMBkAFTgy-DERQPbF0qatgZtlhqk18yQkTUGP1kNbFz2l70Ceu0KtJ2QJpv-gLkZIyR56FhomWC',
  centrifugeUrl: 'wss://stage-app-back.tokentory.com/centrifugo/connection/websocket'
};
